import React from 'react';
import s from './LoadingEllipsis.css';

const LoadingEllipsis = () => <span className={s.ellipsis}>.</span>;

export default LoadingEllipsis;